export const firmware = {
    /**
     * Gets the programmatic name of the entire locale, with the language,
     *   country and variant separated by underbars. The Language is always lower case,
     *   and country is always upper case. If the language is missing,
     *   the string will begin with an underscore character.
     *   If both the language and country fields are missing,
     *   this function will return the empty string,
     *   even if the variant field is filled in (you cannot have a locale with just a variant--
     *   the variant must accompany a valid language or country code). Examples: "en"
     *
     */
    en: {
      location: "Location",
      site: "Site",
      allocate_device:"Allocate Device",
      allocation:"ALLOCATION",
      deAllocation:"DeAllocation",
      serial_no: "Serial No",
      led_model_number: "Led Model Number",
      pole_model_number: "Pole Model Number",
      max_power_consumption:"maxPowerConsumption",
      select_status: "Select status",
      select_location: "Select Location",
      firmware_version: "Firmware Version",
      customer_name: "Customer Name",
      amr_device_id: "AMR Device ID",
      amr_new_device_id: "AMR/New Device ID",
      old_device_id: "Old Device ID",
      amr_offset: "AMR Offset",
      meter_reading: "Meter Reading",
      device_eui: "Dev UI",
      hardware_version: "OEM Name",
      hardware_ver: "OEM Name",
      model_number: "Model Number",
      oem_number: "OEM Number",
      manufacturer: "Manufacturer",
      status: "Status",
      link_ype: "Link Type",
      action: "Action",
      select_manufacturer: "Select Manufacturer",
      select: "Select",
      activate: "Activate",
      command: "Command",
      city: "City",
      area: "Area",
      project_name: "Project Name",
      property_type: "Property Type",
      tower: "Tower",
      flat_property_no: "Flat /Property No",
      attach_available_device: "Attach available device",
      select_city: "Select City",
      select_area: "Select Area",
      select_apartment: "Select Apartment",
      select_tower: "Select Tower",
      command_status: "Command Status",
      response: "Response",
      firmware_onboarding: "Firmware Onboarding",
      add_firmware: "Add Firmware",
      edit_firmware: "Edit Firmware",
      firmware_information: "Firmware Information",
      device_type: "Device Type",
      device_status: "Device Status",
      serial_number: "Serial Number",
      device_name: "Device Name",
      OEM_name: "OEM Name",
      device_properties: "Device Properties",
      firmware_version: "Firmware Version",
      firmware_ver: "Firmware Ver",
      device_latitude: "Device Latitude",
      device_longitude: "Device Longitude",
      download: "download",
      upload: "upload",
      threshold: "Threshold",
      KWH: "KWH",
      KVAH: "KVAH",
      min_value: "Min Value",
      max_value: "Max Value",
      select_manufacture_name: "Select Manufacturer Name",
      manufacture_name: "Manufacturer Name",
      date: "Date",
      time: "Time",
      history: "History",
      assigned: "Assigned",
      assign: "Assign",
      device_allocation:"Device Allocation",
      allocate:"Allocate",
      allocated:"Allocated",
      delete_confrim_msg:"Are you sure you want to delete this firmware?",
      allocation_error_msg:"Please select atleast minimum one device",
      add: {
        success: "Firmware added successfully",
        error: "Unable to add Firmware. Please try again"
      },
      edit: {
        success: "Firmware updated successfully",
        error: "Unable to update Firmware. Please try again"
      },
      get: {
        error: "Unable to find the data. Please try again"
      },
      assign_device: {
        title: "Assign Device to Field Engineer",
        success: "Device assigned successfully",
        error: "Unable to assign device. Please try again",
        customer_all_error:
          "Please select a customer from given option and then choose the device to assign"
      },
      select_min_device: "Please select atleast one device to assign",
      device_inventory: "Assign Device",
      status_history: {
        title: "Device Status History"
      },
      status_change: "Status Change",
      longitude: "Longitude",
      latitude: "Latitude",
      meter_serial_number: "Meter Serial Number",
      amr_serial_number: "AMR Serial Number",
      mobile_number: "Mobile Number",
      device_attach: "Device Attach",
      device_replace: "Device Replace",
      consumer: "Consumer",
      oem_fit: "OEM Fit",
      retro_fit: "Retro Fit",
      replacement: "Replacement",
      replace: "Replace",
      last_close_reading: "Last Close Reading",
      last_meter_reading: "Last Meter Reading",
      comments: "Comments",
      device_detach: "Device Detach",
      date_of_installation: "Date of Installation",
      installed_devices: "Installed Devices",
      active_devices: "Active Devices",
      inactive_devices: "Inactive Devices",
      attach: {
        label: "Attach",
        success: "Device attached to property successfully",
        error: "Unable to attach device to property. Please try again"
      },
      detach: {
        label: "Detach",
        success: "Device detached from property successfully",
        error: "Unable to detach device from property. Please try again"
      },
      consumer_no: "Consumer No.",
      attach_device: "Attach Device",
      offline_configuration: "Offline Configuration",
      offline_days: "Offline Days",
      offline_res: {
        add: {
          success: "Device offline configuration set successfully",
          error: "Unable to set device offline configuration. Please try again"
        },
        edit: {
          success: "Device offline configuration updated successfully",
          error: "Unable to update device offline configuration. Please try again"
        }
      },
      pole_no: "Pole #",
      number_of_lamps: "Number of Lamps",
      firmware_file: "Firmware File",
      supportedModels: "Supported Models",
      file_format:"Only allowed .gbl files",
      file_size:"Size Maximum 20MB"
    },
  
    ar: {
      location: "موقع",
      site: "الموقع",
      allocate_device:"تخصيص الجهاز",
      allocation:"توزيع",
      deAllocation:"إلغاء التخصيص",
      serial_no: "الرقم التسلسلي",
      led_model_number: "رقم موديل الصمام",
      pole_model_number: "رقم موديل القطب",
      select_status: "حدد الحالة",
      device_id: "هوية الجهاز",
      customer_name: "اسم الزبون",
      amr_device_id: "معرّف جهاز AMR",
      amr_new_device_id: "AMR / معرف الجهاز الجديد ",
      old_device_id: "هوية الجهاز القديم",
      amr_offset: "تعويض AMR",
      meter_reading: "قراءة العداد",
      device_eui: "واجهة مستخدم Dev",
      hardware_version: "اسم OEM",
      hardware_ver: "اسم OEM",
      model_number: "رقم الطراز",
      oem_number: "رقم OEM",
      manufacturer: "الصانع",
      status: "الحالة",
      link_ype: "نوع الارتباط",
      action: "عمل",
      select_manufacturer: "حدد الشركة المصنعة",
      select: "اختيار",
      activate: "تفعيل",
      command: "أمر",
      city: "المدينة",
      area: "المنطقة",
      project_name: "اسم المشروع",
      property_type: "نوع الملكية",
      tower: "البرج",
      flat_property_no: "الشقة/رقم العقار",
      attach_available_device: "إرفاق الجهاز المتاح",
      select_city: "اختر مدينة",
      select_area: "حدد المنطقة",
      select_apartment: "اختر شقة",
      select_tower: "حدد برج",
      command_status: "حالة الأمر",
      response: "إجابة",
      device_onboarding: "إعداد الجهاز",
      add_device: "اضف جهاز",
      edit_device: "تحرير الجهاز",
      device_information: "معلومات الجهاز",
      device_type: "نوع الجهاز",
      device_status: "حالة الجهاز",
      serial_number: "رقم سري",
      device_name: "اسم الجهاز",
      OEM_name: "اسم OEM",
      device_properties: "خصائص الجهاز",
      firmware_version: "نسخة برنامج ثابت",
      firmware_ver: "إصدار البرامج الثابتة",
      device_latitude: "جهاز خط العرض",
      device_longitude: "جهاز خط الطول",
      download: "تنزيل",
      upload: "رفع",
      threshold: "الحد الأدنى",
      KWH: "KWH",
      KVAH: "KVAH",
      min_value: "قيمة الحد الأدنى",
      max_value: "قيمة الحد الأقصى",
      select_manufacture_name: "حدد اسم الشركة المصنعة",
      manufacture_name: "اسم المصنع",
      date: "التاريخ",
      time: "الوقت",
      history: "السجل",
      assigned: "مكلف",
      assign: "تعيين",
      device_allocation:"تخصيص الجهاز",
      allocate:"تخصيص",
      allocated:"مخصصة",
      delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا الجهاز؟",
      allocation_error_msg:"الرجاء تحديد جهاز واحد على الأقل",
      add: {
        success: "تمت إضافة الجهاز بنجاح",
        error: "غير قادر على إضافة جهاز. حاول مرة اخرى"
      },
      edit: {
        success: "تم تحديث الجهاز بنجاح",
        error: "تعذر تحديث الجهاز. حاول مرة اخرى"
      },
      get: {
        error: "تعذر العثور على البيانات. حاول مرة اخرى"
      },
      assign_device: {
        title: "تعيين جهاز للمهندس الميداني",
        success: "تم تعيين الجهاز بنجاح",
        error: "تعذر تعيين الجهاز. حاول مرة اخرى",
        customer_all_error:
          "الرجاء تحديد عميل من خيار معين ثم اختيار الجهاز الذي تريد تعيينه"
      },
      select_min_device: "الرجاء تحديد جهاز واحد على الأقل لتعيينه",
      device_inventory: "تعيين الجهاز",
      status_history: {
        title: "محفوظات حالة الجهاز"
      },
      status_change: "تغيير الوضع",
      longitude: "خط الطول",
      latitude: "خط العرض",
      meter_serial_number: "الرقم التسلسلي للعداد",
      amr_serial_number: "الرقم التسلسلي AMR",
      mobile_number: "رقم الهاتف المحمول",
      device_attach: "إرفاق الجهاز",
      device_replace: "استبدال الجهاز",
      consumer: "مستهلك",
      oem_fit: "OEM صالح",
      retro_fit: "ريترو صالح",
      replacement: "إستبدال",
      replace: "يستبدل",
      last_close_reading: "آخر قراءة قريبة",
      last_meter_reading: "قراءة العداد الأخير",
      comments: "التعليقات",
      device_detach: "فصل الجهاز",
      date_of_installation: "تاريخ التركيب",
      installed_devices: "الأجهزة المثبتة",
      active_devices: "الأجهزة النشطة",
      inactive_devices: "الأجهزة غير النشطة",
      attach: {
        label: "يربط",
        success: "تم إرفاق الجهاز بالملكية بنجاح",
        error: "تعذر إرفاق الجهاز بالملكية. حاول مرة اخرى"
      },
      detach: {
        label: "ربط",
        success: "تم فصل الجهاز عن الموقع بنجاح",
        error: "تعذر فصل الجهاز عن الممتلكات. حاول مرة اخرى"
      },
      consumer_no: "رقم المستهلك",
      attach_device: "إرفاق الجهاز",
      offline_configuration: "تهيئة عدم الاتصال",
      offline_days: "أيام دون اتصال بالإنترنت",
      offline_res: {
        add: {
          success: "تم تعيين تكوين الجهاز دون اتصال بنجاح",
          error: "تعذر تعيين تكوين الجهاز دون اتصال. حاول مرة اخرى",
        },
        edit: {
          success: "تم تحديث تكوين الجهاز دون اتصال بنجاح",
          error: "تعذر تحديث تكوين الجهاز دون اتصال. حاول مرة اخرى"
        }
      },
      pole_no: "عمود #",
      number_of_lamps: "عدد المصابيح",
      firmware_file: "ملف البرنامج الثابت",
      supportedModels: "النماذج المدعومة",
      file_format: "يُسمح فقط بملفات .gbl",
      file_size: "الحد الأقصى للحجم 20 ميجابايت"
    }
  };
  